var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { staticClass: "stretch-grid has-search" },
    [
      _c(
        "q-collapsible",
        {
          staticClass: "search-box",
          attrs: {
            id: "userSearchTop",
            "icon-toggle": "",
            "collapse-icon": "fa fa-angle-down"
          },
          model: {
            value: _vm.usersSearchOpen,
            callback: function($$v) {
              _vm.usersSearchOpen = $$v
            },
            expression: "usersSearchOpen"
          }
        },
        [
          _c(
            "template",
            { staticClass: "search-box", slot: "header" },
            [
              _c("q-icon", {
                staticStyle: { padding: "0 0 3px 10px" },
                attrs: { name: "fa fa-search", color: "primary", size: "20px" }
              }),
              _c("div", { staticClass: "pill-slider gt-sm" }, [
                _c("ul", [
                  _vm.$p(["ADMIN"])
                    ? _c(
                        "li",
                        {
                          class: { active: _vm.searchType == "all" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.changeSearchTypeMethod("all")
                            }
                          }
                        },
                        [_vm._v("All")]
                      )
                    : _vm._e(),
                  _vm.$p(["ADMIN"])
                    ? _c(
                        "li",
                        {
                          class: { active: _vm.searchType == "administrators" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.changeSearchTypeMethod("administrators")
                            }
                          }
                        },
                        [_vm._v("Administrators")]
                      )
                    : _vm._e(),
                  _vm.$p(["ADMIN"])
                    ? _c(
                        "li",
                        {
                          class: { active: _vm.searchType == "managers" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.changeSearchTypeMethod("managers")
                            }
                          }
                        },
                        [_vm._v("Managers")]
                      )
                    : _vm._e(),
                  _vm.$p(["ADMIN", "MANAGER", "RECRUITER"], "or")
                    ? _c(
                        "li",
                        {
                          class: { active: _vm.searchType == "affiliates" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.changeSearchTypeMethod("affiliates")
                            }
                          }
                        },
                        [_vm._v("Affiliates")]
                      )
                    : _vm._e(),
                  _vm.$p(["ADMIN", "MANAGER", "AFFILIATE"], "or")
                    ? _c(
                        "li",
                        {
                          class: { active: _vm.searchType == "instructors" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.changeSearchTypeMethod("instructors")
                            }
                          }
                        },
                        [_vm._v("Instructors")]
                      )
                    : _vm._e(),
                  _vm.$p(["ADMIN", "MANAGER"], "or")
                    ? _c(
                        "li",
                        {
                          class: { active: _vm.searchType == "recruiters" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              _vm.changeSearchTypeMethod("recruiters")
                            }
                          }
                        },
                        [_vm._v("Recruiters")]
                      )
                    : _vm._e()
                ])
              ]),
              _c(
                "div",
                { staticClass: "lt-md sl-row", staticStyle: { width: "100%" } },
                [
                  _c(
                    "div",
                    { staticClass: "sl-col-12" },
                    [
                      _c("q-select", {
                        attrs: {
                          "float-label": "User Type",
                          value: _vm.searchType,
                          options: _vm.userTypeOptions
                        },
                        on: {
                          change: function(v) {
                            return _vm.changeSearchType(v)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _vm.searchType === "all"
                ? _c(
                    "div",
                    {
                      staticClass: "sl-row",
                      staticStyle: { padding: "0 30px 5px" }
                    },
                    [
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "First Name" },
                              model: {
                                value: _vm.searchFields.USER_FIRST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "USER_FIRST_NAME",
                                    $$v
                                  )
                                },
                                expression: "searchFields.USER_FIRST_NAME"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Last Name" },
                              model: {
                                value: _vm.searchFields.USER_LAST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "USER_LAST_NAME",
                                    $$v
                                  )
                                },
                                expression: "searchFields.USER_LAST_NAME"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-select", {
                              attrs: {
                                "float-label": "Status",
                                options: _vm.activeIndicators
                              },
                              model: {
                                value: _vm.searchFields.ACTIVE_IND,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchFields, "ACTIVE_IND", $$v)
                                },
                                expression: "searchFields.ACTIVE_IND"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Phone" },
                              model: {
                                value: _vm.searchFields.USER_PHONE,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchFields, "USER_PHONE", $$v)
                                },
                                expression: "searchFields.USER_PHONE"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Email" },
                              model: {
                                value: _vm.searchFields.USER_EMAIL,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchFields, "USER_EMAIL", $$v)
                                },
                                expression: "searchFields.USER_EMAIL"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.searchType === "instructors"
                ? _c(
                    "div",
                    {
                      staticClass: "sl-row",
                      staticStyle: { padding: "0 30px 5px" }
                    },
                    [
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Instructor Code" },
                              model: {
                                value:
                                  _vm.searchFields[
                                    "INSTRUCTOR.INSTRUCTOR_CODE"
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "INSTRUCTOR.INSTRUCTOR_CODE",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['INSTRUCTOR.INSTRUCTOR_CODE']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "First Name" },
                              model: {
                                value: _vm.searchFields.USER_FIRST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "USER_FIRST_NAME",
                                    $$v
                                  )
                                },
                                expression: "searchFields.USER_FIRST_NAME"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Last Name" },
                              model: {
                                value: _vm.searchFields.USER_LAST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "USER_LAST_NAME",
                                    $$v
                                  )
                                },
                                expression: "searchFields.USER_LAST_NAME"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-select", {
                              attrs: {
                                "float-label": "Status",
                                options: _vm.activeIndicators
                              },
                              model: {
                                value:
                                  _vm.searchFields["INSTRUCTOR.ACTIVE_IND"],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "INSTRUCTOR.ACTIVE_IND",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['INSTRUCTOR.ACTIVE_IND']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Affiliate Code" },
                              model: {
                                value:
                                  _vm.searchFields[
                                    "INSTRUCTOR.AFFILIATES.AFFILIATE.AFFILIATE_CODE"
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "INSTRUCTOR.AFFILIATES.AFFILIATE.AFFILIATE_CODE",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['INSTRUCTOR.AFFILIATES.AFFILIATE.AFFILIATE_CODE']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Phone" },
                              model: {
                                value: _vm.searchFields.USER_PHONE,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchFields, "USER_PHONE", $$v)
                                },
                                expression: "searchFields.USER_PHONE"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.searchType === "affiliates"
                ? _c(
                    "div",
                    {
                      staticClass: "sl-row",
                      staticStyle: { padding: "0 30px 5px" }
                    },
                    [
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Affiliate Code" },
                              model: {
                                value:
                                  _vm.searchFields["AFFILIATE.AFFILIATE_CODE"],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "AFFILIATE.AFFILIATE_CODE",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['AFFILIATE.AFFILIATE_CODE']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Affiliate Name" },
                              model: {
                                value:
                                  _vm.searchFields["AFFILIATE.AFFILIATE_NAME"],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "AFFILIATE.AFFILIATE_NAME",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['AFFILIATE.AFFILIATE_NAME']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-select", {
                              attrs: {
                                "float-label": "Status",
                                options: _vm.activeIndicators
                              },
                              model: {
                                value: _vm.searchFields["AFFILIATE.ACTIVE_IND"],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "AFFILIATE.ACTIVE_IND",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['AFFILIATE.ACTIVE_IND']"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Recruiter Code" },
                              model: {
                                value:
                                  _vm.searchFields["RECRUITER.RECRUITER_CODE"],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "RECRUITER.RECRUITER_CODE",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['RECRUITER.RECRUITER_CODE']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Processing Fee" },
                              model: {
                                value:
                                  _vm.searchFields[
                                    "AFFILIATE.STUDENT_PROCESSING_FEE"
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "AFFILIATE.STUDENT_PROCESSING_FEE",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['AFFILIATE.STUDENT_PROCESSING_FEE']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Phone" },
                              model: {
                                value: _vm.searchFields.USER_PHONE,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchFields, "USER_PHONE", $$v)
                                },
                                expression: "searchFields.USER_PHONE"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.searchType === "administrators"
                ? _c(
                    "div",
                    {
                      staticClass: "sl-row",
                      staticStyle: { padding: "0 30px 5px" }
                    },
                    [
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "First Name" },
                              model: {
                                value: _vm.searchFields.USER_FIRST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "USER_FIRST_NAME",
                                    $$v
                                  )
                                },
                                expression: "searchFields.USER_FIRST_NAME"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Middle Name" },
                              model: {
                                value: _vm.searchFields.USER_MIDDLE_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "USER_MIDDLE_NAME",
                                    $$v
                                  )
                                },
                                expression: "searchFields.USER_MIDDLE_NAME"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Last Name" },
                              model: {
                                value: _vm.searchFields.USER_LAST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "USER_LAST_NAME",
                                    $$v
                                  )
                                },
                                expression: "searchFields.USER_LAST_NAME"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Phone" },
                              model: {
                                value: _vm.searchFields.USER_PHONE,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchFields, "USER_PHONE", $$v)
                                },
                                expression: "searchFields.USER_PHONE"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Email" },
                              model: {
                                value: _vm.searchFields.USER_EMAIL,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchFields, "USER_EMAIL", $$v)
                                },
                                expression: "searchFields.USER_EMAIL"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.searchType === "recruiters"
                ? _c(
                    "div",
                    {
                      staticClass: "sl-row",
                      staticStyle: { padding: "0 30px 5px" }
                    },
                    [
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Affiliate Code" },
                              model: {
                                value:
                                  _vm.searchFields[
                                    "RECRUITER.AFFILIATES.AFFILIATE_CODE"
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "RECRUITER.AFFILIATES.AFFILIATE_CODE",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['RECRUITER.AFFILIATES.AFFILIATE_CODE']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Affiliate Name" },
                              model: {
                                value:
                                  _vm.searchFields[
                                    "RECRUITER.AFFILIATES.AFFILIATE_NAME"
                                  ],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "RECRUITER.AFFILIATES.AFFILIATE_NAME",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['RECRUITER.AFFILIATES.AFFILIATE_NAME']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-select", {
                              attrs: {
                                "float-label": "Status",
                                options: _vm.activeIndicators
                              },
                              model: {
                                value: _vm.searchFields["RECRUITER.ACTIVE_IND"],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "RECRUITER.ACTIVE_IND",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['RECRUITER.ACTIVE_IND']"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Recruiter Code" },
                              model: {
                                value:
                                  _vm.searchFields["RECRUITER.RECRUITER_CODE"],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "RECRUITER.RECRUITER_CODE",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['RECRUITER.RECRUITER_CODE']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Recruiter Fee" },
                              model: {
                                value:
                                  _vm.searchFields["RECRUITER.RECRUITER_FEE"],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "RECRUITER.RECRUITER_FEE",
                                    $$v
                                  )
                                },
                                expression:
                                  "searchFields['RECRUITER.RECRUITER_FEE']"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Phone" },
                              model: {
                                value: _vm.searchFields["USER_PHONE"],
                                callback: function($$v) {
                                  _vm.$set(_vm.searchFields, "USER_PHONE", $$v)
                                },
                                expression: "searchFields['USER_PHONE']"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.searchType === "managers"
                ? _c(
                    "div",
                    {
                      staticClass: "sl-row",
                      staticStyle: { padding: "0 30px 5px" }
                    },
                    [
                      _c("div", { staticClass: "sl-row no-margin" }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "First Name" },
                              model: {
                                value: _vm.searchFields.USER_FIRST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "USER_FIRST_NAME",
                                    $$v
                                  )
                                },
                                expression: "searchFields.USER_FIRST_NAME"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-4" },
                          [
                            _c("q-input", {
                              attrs: { "float-label": "Last Name" },
                              model: {
                                value: _vm.searchFields.USER_LAST_NAME,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchFields,
                                    "USER_LAST_NAME",
                                    $$v
                                  )
                                },
                                expression: "searchFields.USER_LAST_NAME"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _c(
                "q-toolbar",
                {
                  staticStyle: { "padding-right": "60px" },
                  attrs: { color: "white" }
                },
                [
                  _c("q-toolbar-title"),
                  _c("q-btn", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: {
                      color: "secondary",
                      label: "Clear",
                      outline: "",
                      size: "sm",
                      type: "reset"
                    },
                    on: { click: _vm.fetchAndClear }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "primary",
                      label: "Search",
                      size: "sm",
                      type: "submit"
                    },
                    on: {
                      click: function($event) {
                        _vm.fetchMethod()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c("Grid", {
        attrs: {
          id: "userListGrid",
          module: _vm.module,
          data: _vm.userList,
          columns: _vm.columnOptions,
          onLaunch: _vm.selectUser,
          loading: _vm.loadingData,
          onRequest: _vm.fetch,
          onExport: _vm.fetch,
          visibleColumns: _vm.getVisibleColumns
        },
        scopedSlots: _vm._u([
          {
            key: "col-item-active_ind",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      green: props.value === true,
                      red: props.value === false
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(props.value ? "Active" : "Inactive") +
                        "\n            "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "col-item-affiliate_active_ind",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      green: props.value == 1,
                      red: props.value == 0
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(props.value ? "Active" : "Inactive") +
                        "\n            "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "col-item-manager_active_ind",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      green: props.value == true,
                      red: props.value == false
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(props.value ? "Active" : "Inactive") +
                        "\n            "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "col-item-instructor_active_ind",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      green: props.value == true,
                      red: props.value == false
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(props.value ? "Active" : "Inactive") +
                        "\n            "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "col-item-recruiter_active_ind",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      green: props.value == true,
                      red: props.value == false
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(props.value ? "Active" : "Inactive") +
                        "\n            "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "col-item-instructor_associated_affiliates",
            fn: function(props) {
              return _vm._l(props.value, function(item, idx) {
                return _c(
                  "div",
                  {
                    key: idx,
                    staticClass: "label blue",
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px",
                      "text-align": "left"
                    }
                  },
                  [_vm._v("\n              " + _vm._s(item) + "\n            ")]
                )
              })
            }
          },
          {
            key: "col-item-affiliate_recruiter",
            fn: function(props) {
              return [
                props.value
                  ? _c(
                      "div",
                      {
                        staticClass: "label blue",
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "10px",
                          "border-radius": "30px"
                        }
                      },
                      [_vm._v("\n        " + _vm._s(props.value) + "\n      ")]
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "col-item-print_permissions",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      green: props.value == true,
                      red: props.value == false
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(props.value ? "Enabled" : "Disabled") +
                        "\n      "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "col-item-school_entered",
            fn: function(props) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "label",
                    class: {
                      green: props.value == true,
                      red: props.value == false
                    },
                    staticStyle: {
                      display: "inline-block",
                      "margin-left": "10px",
                      "border-radius": "30px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(props.value ? "Yes" : "No") +
                        "\n      "
                    )
                  ]
                )
              ]
            }
          }
        ])
      }),
      _vm.$p(["ADMIN", "MANAGER", "RECRUITER", "AFFILIATE"], "or")
        ? _c(
            "q-layout-footer",
            [
              _c(
                "q-toolbar",
                [
                  _c("q-toolbar-title"),
                  _c("q-btn", {
                    attrs: { label: "New User", icon: "add", color: "primary" },
                    on: {
                      click: function($event) {
                        _vm.openUserWizardModal()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }